"use strict";
const AirtablePlus = require('./lib/AirtablePlus');

module.exports = AirtablePlus;